export default __webpack_public_path__ + "static/media/benefit2.b967229c.png";